import { NgModule } from '@angular/core';
import { NgxLoadingModule } from 'ngx-loading';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AuthInterceptor } from './interceptor/auth.interceptor';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { NgbDateFormatterService } from '@service/ngb-date-formatter.service';

import { LOADING_CONFIG, TRANSLATE_CONFIG } from './core.config';
import { PostMessageModule } from './postmessage';

@NgModule({
  imports: [
    NgbModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PostMessageModule,
    NgxLoadingModule.forRoot(LOADING_CONFIG),
    TranslateModule.forRoot(TRANSLATE_CONFIG)
  ],
  exports: [NgbModule, TranslateModule, HttpClientModule, NgxLoadingModule],
  providers: [
    NgbDateFormatterService,
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateFormatterService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {}
